import { FunctionComponent, useState } from 'react'
import MembersSearch from './MembersSearch'
import MembersListing from './MembersListing'
import { IMembersSearchResults } from 'Frontend/scripts/models/members.model'

const MembersListingPage: FunctionComponent = () => {
  const [ListOfMembersData, setListOfMembersData] = useState<IMembersSearchResults>()
  const [selectedQuery, setSelectedQuery] = useState<string>()
  const [selectedCounty, setSelectedCounty] = useState<string>()
  const [selectedMunicipality, setSelectedMunicipality] = useState<string>()
  const [selectedCompetence, setSelectedCompetence] = useState<string>()
  return (
    <>
      <MembersSearch
        callback={(members, selectedQuery, selectedCounty, selectedMunicipality, selectedCompetence) => {
          setListOfMembersData(members)
          setSelectedQuery(selectedQuery)
          setSelectedCounty(selectedCounty)
          setSelectedMunicipality(selectedMunicipality)
          setSelectedCompetence(selectedCompetence)
        }}
      />
      <MembersListing
        membersList={ListOfMembersData as IMembersSearchResults}
        selectedQuery={selectedQuery}
        selectedCounty={selectedCounty}
        selectedMunicipality={selectedMunicipality}
        selectedCompetence={selectedCompetence}
      />
    </>
  )
}

export default MembersListingPage
